<template>
    <main role="main">
        <article v-show="!pending" :data-details="true" class="layout-contents-container">
            <div class="layout-page-title">
                <button class="buttons-icon" data-icon="back" data-type="line" type="button" @click="goBack()">Back
                </button>
                <h1 class="page-title">
                    <template>
                        {{ $t('POLICY.LABEL.COPY_POLICY') }}<!--정책 복사-->
                    </template>
                </h1>
            </div>
            <!-- SUB TITLE -->
            <!-- Policy 복사일 때 -->
            <div class="layout-contents">

                <fieldset class="forms">
                    <legend>{{ $t('POLICY.LABEL.POLICY_COPY_FORM') }}</legend>
                    <table class="tbl-forms">
                        <caption></caption>
                        <tbody>
                        <tr>
                            <td colspan="2">{{ $t('POLICY.LABEL.COPY_POLICY_DESC') }}
                                <!--정책을 복사하여 사용자 환경에 맞게 설정된 내용을 수정할 수 있습니다.--> </td>
                        </tr>
                        <tr>
                            <th>
                                <label>{{ $t('LABEL.POLICY_NAME') }}<!--정책 이름--><span
                                    class="icon-required">{{ $t('COMMON.FIELD_REQUIRE') }}</span></label>
                            </th>
                            <td>
                                <input v-model="plcy.transTitl" :data-invalid="invalidPolicyTitle || duplicatedPolicyTitle ? true : null" class="text-field" maxlength="100"
                                       placeholder="이름을 입력하세요."
                                       style="width: 400px;" type="text"
                                       @input="plcy.titl = $event.target.value; isInvalidPolicyTitle();">
                                <p v-if="invalidPolicyTitle" class="invalid-message">{{ $t('POLICY.INVALID.TITLE') }}
                                    <!--정책 이름을 입력해주세요.--></p>
                                <p v-if="duplicatedPolicyTitle" class="invalid-message">
                                    {{ $t('POLICY.INVALID.DUPLICATE') }}<!--이미 사용 중인 이름입니다.--></p>
                            </td>
                    </tr>
                        <tr>
                            <th>
                                <label>{{ $t('LABEL.DESCRIPTION') }}<!--설명--></label>
                            </th>
                            <td>
                                <input v-model="plcy.desc" class="text-field" placeholder="" style="width: 800px;"
                                       type="text">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <!-- 적용된 규칙 -->
                    <!-- rulelist of replica -->
                    <RuleList
                        :key="getLocale"
                        :callDeleteRule="deleteGovernanceRule"
                        :callOpenPopup="openAddRulePopup"
                        :callOpenRuleDetail="openRuleDetail"
                        :callSetSearchKey="setSearchKey"
                        :callSetSortColumn="setSortColumn"
                        :categoryList="categoryList"
                        :cur-rule="detailRuleInfo"
                        :isReplica="isReplica"
                        :policy="plcy"
                        :ruleList="govRuleListByKey"
                        :templateList="templateList"
                        :menuAuth="getMenuAuth"
                        :originalRuleList="govRuleList"
                        :callImportRule="openImportRule"
                    />
                    <div class="forms-submit">
                        <button class="buttons" data-size="l" type="button" @click="goBack()">
                            {{ $t('COMMON.BUTTON.CAMEL.CANCEL') }}<!--취소--></button>
                        <button class="buttons" data-size="l" data-type="key" type="button"
                                @click="insertReplicaPolicy()">{{ $t('COMMON.BUTTON.UPPER.OK') }}<!--확인--></button>
                    </div>
                </fieldset>

            </div>
        </article>
        <AddRuleModal
            ref="popUpModal"
            :callLoading="callLoading"
            :callSaveRule="insertGovernanceRule"
            :callSetActionList="setActionList"
            :actionTemplateList="actionTemplateList"
            :categoryList="categoryList"
            :newTmplt="newTmplt"
            :rule="rule"
            :userList="userList"
            :alertOptions="alertOptions"
            :roleCode="roleCode"
        />
        <Modal
            ref="plcySingleModal"
            :okFunction="handleModalOkFunc"
            :title="modal.popupTitle"
            :message="modal.popupMessage"
            :isShowPopup="modal.isShowPopup"
            :callOnHide="handleHideModal"
            :btnOkStyle="modal.btnOkStyle">
            <template
                v-if="modal.popupType === 'addSchePopup'"
                v-slot:body-template>
                <AddingSchePopup
                    :callSetScheInfo="setScheInfo"
                />
            </template>
        </Modal>
        <CustomModal
            :callOnHide="onHideCModal"
            :isShowPopup="cmodal.isShowPopup"
            :title="cmodal.popupTitle"
            :message="cmodal.popupMessage"
            :callAction2="()=>{refPlcy = []}"
            :callAction3="getRuleFromOtherPlcy"
            :isShowBtn1=false
            :disableBtn3="disableBtn3"
            btn2style="light"
            :btn2Txt="cmodal.btn2Txt"
            :btn3Txt="cmodal.btn3Txt"
            size="xl"
        >
            <template v-slot:body-template class="import-template">
                <ImportRuleForm
                    :currentCmpnId="curCmpnId"
                    @callSetSelectValue="getSlctRule"
                />
            </template>
        </CustomModal>
        <div-loading v-if="pending" :full="true"></div-loading>
    </main>
</template>
<script>

import ImportRuleForm from "./policyComponents/ImportRuleForm.vue"
import RuleList from "../rule/RuleList.vue";
import PolicySideRuleDetail from "./policySideRuleDetail.vue";
import {EventBus} from "../common/event-bus";
import AddRuleModal from "./policyComponents/AddRuleModal.vue";
import Modal from "../common/Modals/Modal.vue";
import AddingSchePopup from "../policy/policyComponents/AddingSchePopup.vue";
import CustomModal from "../common/Modals/CustomModal.vue"
import _ from "lodash";
import {mapGetters} from "vuex";

export default {
    name: 'policyReplica',
    components: {
        'side-rule-detail': PolicySideRuleDetail,
        RuleList,
        AddRuleModal,
        Modal,
        AddingSchePopup,
        CustomModal,
        ImportRuleForm
    },
    data() {
        return {
            tempSlctRule:{},
            totalSlctedRule: [],
            isImportRule: false,
            tempRefPlcy: [],
            refPlcy: [],
            cmodal: {
                isShowPopup: false,
            },
            selectedPlcyScheInfo: {
                doCmpl: true,
            },
            modal: {
                isShowPopup: false,
            },
            delRuleList: [],
            message: '메시지',
            isEdit: false, // Rule Popup 등록, 수정 상태 체크
            isCopy: false, // Rule Popup 등록, 수정 상태 체크
            doRefresh: false, // rule list refresh 값
            plcy: {},
            originPlcy: {},
            categoryList: [],
            actionTemplateList: [], // Action Template List
            userList: [], // User List for Action
            detailRuleInfo: {},
            rule: {}, // popup 에 보내줄 rule 데이터
            newTmplt: [], //
            invalidPolicyTitle: false, // Policy Title 유효성 검사
            duplicatedPolicyTitle: false, // Policy Title 중복 검사
            fEdit: {
                titl: false,
                desc: false
            },
            pending: false,
            govRuleList: [],
            govRuleListByKey: [],
            policyDetail: {},
            searchSvrty: this.constants.PARAM.SELECT.SEARCH_SEVERITY,                     // SearchList of Severity : 처음 전체선택으로 모든 값 넣어줌
            sortColumn: '',                                // Sort column
            sortOrder: '',                                 // Sort order
            ruleListSearchKey: {},
            disableBtn3: true,
            tempRules: [],
            isLoading: false,
            alertOptions: [],
            roleCode: null,
        }
    },
    created: function () {
        this.slctPlcy();
        this.selectCategoryList();
        this.selectActionTemplateList();
        this.selectUserList();
        this.selectGovernanceRuleList();
        EventBus.$on("emit-copy-rule", ruleId => {
            this.openCopyRulePopup(ruleId)
        });
    },
    mounted: function () {
        this.setManagementOptions();
        this.getAlertCreatePermission();
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId',
            policyHistory: 'user/policyHistory',
            loginUser: 'user/loginUser'
        }),
        getMenuAuth: function () {
            //메뉴 별 권한
            let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.POLICY})
            return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
        },
        templateList: function () {
            return this.$store.state.templateList;
        },
        // url 에 /replica 가 있으면 Policy 복사로 들어온 것
        isReplica: function () {
            return this.$route.path.indexOf('/replica') > -1;
        },
        rvsnId: {
            get: function () {
                return this.$route.query.rvsn;
            },
            set: function (value) {
                return this.$route.query.rvsn = value;
            }
        },
        getLocale: function () {
            return this.$i18n.locale
        }
    },
    watch: {
        curCmpnId: function () {
            this.$router.push(`/policy`)
        },
        doRefresh() {
            this.slctPlcy();
            this.selectGovernanceRuleList();
        }
    },
    methods: {
        async getAlertAction() {
            const url = `/api/external/${this.curCmpnId}/${this.loginUser.userId}`;
            const response = await this.http.get(url);
            const options = _.get(response, "data.data");
            if (options) {
                options.forEach(opt => {
                    opt.key = opt.unqKey,
                    opt.value = opt.dispNm
                })
            }            
            this.alertOptions = this.alertOptions.concat(options);
        },
        async getAlertCreatePermission() {
            const {ADMIN, SERVICE_MANAGER} = this.constants.ROLE_CODE;
            const url = `/api/external/${this.curCmpnId}/${this.loginUser.userId}/role`;
            const response = await this.http.get(url);
            
            const roleCode = _.get(response, "data.data.roleCode");
            if (roleCode === ADMIN) {
                this.alertOptions.push({key: 'NEW', value: 'Create New'});
            }
            if (roleCode === ADMIN || roleCode === SERVICE_MANAGER) {
                await this.getAlertAction();
            }
            this.roleCode = roleCode;
        },
        getObjValues(tempSlctRule) {
            const rsrc = Object.values(tempSlctRule);
            return rsrc.flat();
        },
        setImportRuleSrchTxt(txt) {
            this.importRuleSrchTxt = txt;
        },
        reformatRule(raw) {
            const rule = raw;
            rule.cndVal = JSON.parse(raw.cndVal);
            rule.ctgLabel = JSON.parse(raw.ctgLabel);
            rule.actnVal = JSON.parse(raw.actnVal);
            let transTitl = this.$t("TEMPLATE." + raw.titl);
            if (transTitl.indexOf("TEMPLATE.") != -1) {
                transTitl = raw.titl;
            }
            rule.transTitl = transTitl;

            return rule;
        },
        async getRuleFromOtherPlcy() {
            this.isImportRule = true;
            this.refPlcy = this.tempRefPlcy.map(policy => policy.rvsnId);
            const url = "/api/governance/rule/list";
            const header = {
                cmpnId: this.curCmpnId,
                plcyRvsnIds: this.refPlcy
            }
            const response  = await this.http.post(url, JSON.stringify(header));
            if (response.data.status != 'fail') {
                console.log("getRuleFromOtherPlcy ", response.data);
                const rules = _.get(response, "data.result");
                rules.forEach((rule) => {
                    const eRule = this.reformatRule(rule);
                    this.addRule(eRule);
                });
            }

            let tempRules = this.getObjValues(this.tempRules);
            if (tempRules.length != 0) {
                tempRules.forEach((rule) => {
                    this.addRule(rule);
                });
            }
        },
        getSlctRule(evnt) {
            this.tempRefPlcy = evnt.policys;
            this.tempRules = evnt.rules;
            if (this.tempRefPlcy.length != 0 || this.tempRules.length != 0) {
                this.disableBtn3 = false;
            } else {
                this.disableBtn3 = true;
            }
        },
        setRowsPerPage(rpp) {
            this.paging.currentPage = rpp.currentPage;
            this.paging.rowPerPage = rpp.rowsPerPage;
        },
        setCurrentPage(e) {
            this.paging.currentPage = e;
        },
        onHideCModal() {
            this.disableBtn3 = true;
            this.cmodal = {
                isShowPopup: false
            }
        },
        async openImportRule() {
            this.cmodal = {
                isShowPopup: true,
                popupTitle: this.$t('COMMON.POPUP.TITLE.IMPORT_RULE'),
                popupMessage: this.$t('COMMON.POPUP.DESC.IMPORT_RULE'),
                btn2Txt: this.$t('COMMON.BUTTON.CAMEL.CANCEL'),
                btn3Txt: this.$t('COMMON.BUTTON.UPPER.OK')
            }
        },
        editTransInfo(rule) {
            const eRule = rule;
            const localeSupport = ['en', 'ko', 'zh', 'jp'];
            localeSupport.forEach((locale)=>{
                if (locale != this.getLocale) {
                    eRule[`${locale}RuleDesc`] = "";
                    eRule[`${locale}RuleRemd`] = "";
                    eRule[`${locale}RuleTitle`] = "";
                } else {
                    eRule[`${locale}RuleDesc`] = rule.transDesc;
                    eRule[`${locale}RuleRemd`] = rule.transRemd;
                    eRule[`${locale}RuleTitle`] = rule.transTitl;
                }
            });
            eRule.titl = rule.transTitl;
            return eRule;
        },
        async deleteRule() {
            this.removeRule(this.delRuleList);
            EventBus.$emit('toastComment', 'POLICY.TOAST.DELETED_RULE');
        },
        setScheInfo(scheInfo) {
            this.selectedPlcyScheInfo = {...this.selectedPlcyScheInfo, ...scheInfo};
        },
        handleHideModal() {
            if (this.modal.popupType === 'addSchePopup') {
                this.setScheInfo({doCmpl: true});
            }
            this.modal.isShowPopup = false;
        },
        setSortColumn(sortColumn) {
            const sortObject = this.Common.setSortColumn(this.sortColumn, this.sortOrder, sortColumn);
            this.sortColumn = sortObject.sortColumn;
            this.sortOrder = sortObject.sortOrder;
            this.getRuleByKey();
        },
        setSearchKey(key, value) {
            this.ruleListSearchKey = {
                ...this.ruleListSearchKey,
                [key]: value
            };
            this.getRuleByKey();
        },
        getRuleByKey() {
            const {searchTxt, searchCtg, searchProd} = this.ruleListSearchKey;
            let self = this;
            let filtered = _.cloneDeep(this.govRuleList);
            filtered = _.forEach(filtered, function (o) {
                _.forEach(o.cndVal, function (k) {
                    let ruleProd = _.find(self.templateList, {'tmpltId': k.tmpltId})
                    if (typeof (ruleProd) !== 'undefined') {
                        o.prodNm = ruleProd.prod
                    }
                })
            })
            // Text filter
            if (!this.Common.isEmptyText(searchTxt)) {
                filtered = this.govRuleList.filter((item) => {
                    const ruleName = item[`${this.getLocale}RuleTitle`];
                    if (ruleName) {
                        return ruleName.toLowerCase().includes(searchTxt.toLowerCase());
                    } else {
                        return item.titl.toLowerCase().includes(searchTxt.toLowerCase());
                    }
                })
            }
            // Category filter
            if (typeof (searchCtg) !== 'undefined' && searchCtg.length > 0) {
                filtered = _.filter(filtered, function (o) {
                    for (let srchCtg of searchCtg) {
                        if (_.includes(o.ctgLabel, srchCtg)) {
                            return true;
                        }
                    }
                    return false;
                })
            }
            // Product filter
            if (typeof (searchProd) !== 'undefined' && searchProd.length > 0) {
                let manualRules = [];
                if (searchProd.includes('manual')) {
                    manualRules = _.cloneDeep(_.filter(filtered, {'autoExeYn': 'N'}));
                }
                filtered = _.filter(filtered, function (o) {
                    let fill = _.filter(o.cndVal, function (k) {
                        let ruleProd = _.find(self.templateList, {'tmpltId': k.tmpltId})
                        for (let srchProd of searchProd) {
                            if (ruleProd && ruleProd.prod === srchProd) {
                                return true;;
                            }
                        }
                        return false;
                    })
                    return fill.length > 0;
                })
                filtered = filtered.concat(manualRules);
            }
            if (this.searchSvrty.length !== this.constants.SVRTY_FILTER.length) {
                filtered = filtered.filter((p) => {
                    return _.includes(this.searchSvrty, p.svrty)
                })
            }
            // Sorting 처리
            if (this.sortColumn !== '' && this.sortOrder !== '') {
                filtered = _.orderBy(filtered, [this.sortColumn], [self.sortOrder])
            }
            this.govRuleListByKey = filtered;
        },
        removeRule(items) {
            const listToRemove = [];
            items.forEach((item)=>{
                const selectedRule = _.find(this.govRuleListByKey, (rule)=>{
                    return rule.ruleId === item.ruleId;
                })
                if (selectedRule) {
                    listToRemove.push(selectedRule);
                }
            })
            this.govRuleListByKey = _.difference(this.govRuleListByKey, listToRemove);
            this.govRuleList = _.cloneDeep(this.govRuleListByKey);
        },
        getRuleListOnlyReplica() {
            let list = _.cloneDeep(this.govRuleListByKey);
            const locale = this.getLocale;
            for (let rule of list) {
                const userDefined = rule.userDefiYn === this.constants.PARAM.SELECT.N;
                rule.titl = userDefined ? rule[`${locale}RuleTitle`] : rule.titl;
                rule.desc = userDefined ? rule[`${locale}RuleDesc`] : rule.desc;
                rule.remd = userDefined ? rule[`${locale}RuleRemd`] : rule.remd;
                rule.cmpnId = this.curCmpnId;
                rule.cndVal = JSON.stringify(rule.cndVal)
                rule.actnVal = JSON.stringify(rule.actnVal)
                rule.ctgLabel = JSON.stringify(rule.ctgLabel)
            }
            return list
        },
        async selectGovernanceRuleList() {
            const url = '/api/governance/rule/list';
            const ruleData = {
                cmpnId: this.curCmpnId,
                rvsnId: this.rvsnId
            }
            const result  = await(this.http.post(url, ruleData));
            if (result && result.data.status === 'ok') {
                // for 에서 text 를 json 으로 parse
                for (let rule of result.data.result) {
                    rule.transTitl = rule.userDefiYn === this.constants.PARAM.SELECT.N ? this.rule[this.getLocale + 'RuleTitle'] : rule.titl;
                    rule.transDesc = rule.userDefiYn === this.constants.PARAM.SELECT.N ? this.rule[this.getLocale + 'RuleDesc'] : rule.desc;
                    rule.transRemd = rule.userDefiYn === this.constants.PARAM.SELECT.N ? this.rule[this.getLocale + 'RuleRemd'] : rule.remd;
                    rule.cndVal = this.Common.parseJSON(rule.cndVal);
                    rule.actnVal = this.Common.parseJSON(rule.actnVal)
                    rule.ctgLabel = this.Common.parseJSON(rule.ctgLabel)
                }
                this.govRuleList = result.data.result;
                this.getRuleByKey();
            }
        },
        callLoading(isLoading) {
            this.pending = isLoading;
        },
        async slctPlcy() {
            this.pending = true;
            const url = "/api/governance/policy/policy";
            const header = {
                cmpnId: this.curCmpnId,
                rvsnId: this.rvsnId
            };
            try {
                const result = await(this.http.post(url, JSON.stringify(header)));
                const plcy = _.get(result, "data.result", null);
                if (plcy) {
                    plcy.transTitl = plcy.userDefiYn === this.constants.PARAM.SELECT.N ? plcy[this.getLocale + 'Title'] : plcy.titl;
                    plcy.desc = plcy[this.$i18n.locale + 'Desc'] || plcy.desc;
                    plcy.titl = plcy.transTitl;
                    this.plcy = plcy;
                    this.originPlcy = _.cloneDeep(plcy);
                }
            } catch (error) {
                console.error("slctPlcy error: ", error);
            } finally {
                this.pending = false;
            }
        },
        // Policy Title, Description 수정
        async updtPlcy(item) {
            if (this.isInvalidPolicyTitle()) return;
            const plcyData = {
                cmpnId: this.curCmpnId,
                plcyId: this.plcy.plcyId,
                rvsnId: this.rvsnId,
                desc: this.plcy.desc
            };
            if (item === 'titl') {
                plcyData.titl = this.plcy.titl;
            }
            const url = "/api/governance/policy";
            try {
                EventBus.$emit('toastComment', 'POLICY.TOAST.EDITED_RULE');
                const result = await(this.http.put(url, plcyData));
                if (result.data.status === 'ok') {
                    this.changeEditStatus(item, false);
                    this.originPlcy = _.cloneDeep(this.plcy);
                    this.$router.replace(`/policy/${result.data.result.rvsnId}`);
                } else if (result.data.status === 'fail' && result.data.error.message === 'ERROR_D') {
                    // 타이틀 중복 처리
                    this.duplicatedPolicyTitle = true;
                }
            } catch (error) {
                console.error("updtPlcy: ", error);
            }
        },
        // Category 목록 조회. Popup, Detail 둘 다 사용하기때문에 여기서 조회
        selectCategoryList() {
            var url = `/api/governance/category/list/simple`;
            var body = {
                "cmpnId": this.curCmpnId
            };

            this.http.post(url, body)
                .then(response => {
                    this.categoryList = response.data.result;
                });
        },
        // Action 목록 조회
        async selectActionTemplateList() {
            // Action List 초기화
            this.actionTemplateList = [];

            const url = "/api/governance/actn";
            const response = await(this.http.get(url));
            this.actionTemplateList = response.data.result;
        },
        // Action Email 에서 사용할 사용자 List 가져오기
        async selectUserList() {
            var url = '/api/governance/user/list';
            var header = {
                'cmpnId': this.$store.state.loginUser.curCmpnId
            };
            const response = await(this.http.post(url, header));
            if (response.data.status === 'ok') {
                this.userList = response.data.result;
            }
        },
        convertUtcTimezoneToLocal: function (date) {
            return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
        },
        setActionList(selectedTemplateList) {
            let actionListBySelectedTemplate = (_.filter(this.actionTemplateList, {'prod': 'default'}));
            _.forEach(_.groupBy(selectedTemplateList, 'prod'), function (value, key) {
                actionListBySelectedTemplate = actionListBySelectedTemplate.concat(_.filter(self.actionTemplateList, {'prod': key}));
            });
        },
        // Open side rule view
        openRuleDetail: function (rule) {
            this.detailRuleInfo = rule
            typeof ($('.layout-contents').attr('data-side-expand')) === 'undefined' ? $('.layout-contents').toggleAttr('data-side-expand', '') : false
        },
        editRule(rule) {
            const idx = _.findIndex(this.govRuleListByKey, (o) => {
                return o.ruleId === rule.ruleId;
            });
            const eRule = this.editTransInfo(rule);
            this.$set(this.govRuleListByKey, idx, eRule);
        },
        addRule(rule) {
            const eRule = this.editTransInfo(rule);
            const found = this.govRuleListByKey.find(element => element.ruleId === eRule.ruleId)
            if (!found) {
                this.govRuleListByKey.push(eRule);
                this.govRuleList = this.govRuleListByKey;
            }
        },
        // isEdit 로 구분해서 Insert, Update 함
        async insertGovernanceRule(rule) {
            const url = "/api/governance/rule";
            // Policy 복제일 때
            if (this.isEdit) {
                this.editRule(rule)
                // case1. policy 복사에서 룰 수정
                EventBus.$emit('toastComment', 'POLICY.TOAST.EDITED_RULE')
            } else {
                rule.ruleId = this.Common.uuid()
                this.addRule(rule);
                if (typeof (this.isEdit) === 'undefined') {
                    // case2. policy 복사에서 룰 복사
                    EventBus.$emit('toastComment', 'POLICY.TOAST.COPIED_RULE')
                } else {
                    // case3. policy 복사에서 룰 추가
                    EventBus.$emit('toastComment', 'POLICY.TOAST.ADDED_RULE')
                }
            }
            this.pending = false
        },
        deleteGovernanceRule(delRuleList) {
            this.delRuleList = delRuleList;
            this.modal = {
                popupTitle: this.$t('POLICY.RULE.POPUP.TITLE.DELETE'),
                popupMessage: this.$t('POLICY.RULE.POPUP.DESC.DELETE'),
                isShowPopup: true,
                popupType: 'delRule',
                btnOkStyle: 'danger'
            }
        },
        // Rule 기본되는 값
        getDefaultRuleObject() {
            return {
                titl: '',
                actnExeYn: 'Y',
                ctgLabel: [],
                cndVal: [{
                    tmpltId: 'new',
                    cjt: null
                }],
                svrty: 1,
                actnVal: [{
                    actnId: null
                }],
            };
        },
        goBack() {
            this.$router.go(-1)
        },
        handleModalOkFunc() {
            if (this.modal.popupType === 'addSchePopup') {
                this.addPolicyToCompliance();
            } else {
                this.handleActionModal();
            }
        },
        async handleActionModal() {
            if (this.modal.popupType === "delPlcy") {
                const {cmpnId, plcyId, rvsnId} = this.plcy;
                const header = {
                    cmpnId,
                    plcyId,
                    rvsnId
                };
                const url = "/api/governance/policy/delete";
                this.http.post(url, JSON.stringify(header))
                    .then(response => {
                        this.$router.push('/policy')
                    });
            } else if (this.modal.popupType === "delRule") {
                this.deleteRule();
            }
        },
        openCopyRulePopup: function (ruleId) {
            this.openPopup(data)
        },
        // Replica Policy 등록
        async insertReplicaPolicy() {
            this.pending = true;
            // Policy Title 에 대한 유효성 검사
            if (this.isInvalidPolicyTitle()) return;
            // 복사본이며 동시에 사용자 정의 폴리시이다. 현재 회사 ID로 폴리시를 등록해야 함.
            let plcy = this.plcy;
            plcy.rplcYn = 'Y';
            plcy.userDefiYn = 'Y';
            plcy.cmpnId = this.curCmpnId;
            plcy.title = this.getLocale + this.plcy.title;
            const rule = await this.getRuleListOnlyReplica();
            const data = {
                plcy,
                rule
            };

            const url = '/api/governance/policy/replica';
            const response = await(this.http.post(url, JSON.stringify(data)));
            if (response.data.status === 'ok') {
                this.$router.push('/policy');
                EventBus.$emit('toastComment', 'POLICY.TOAST.COPIED_POLICY');
            } else if (response.data.status === 'fail' && response.data.error.message === 'DUPLICATE POLICY TITLE') {
                // 타이틀 중복 처리
                this.duplicatedPolicyTitle = true;
            }
            this.pending = false;
        },

        // 유효성 검사
        isInvalidPolicyTitle() {
            this.duplicatedPolicyTitle = false
            this.invalidPolicyTitle = !!this.Common.isEmptyText(this.plcy.titl);
            return this.invalidPolicyTitle
        },
        openAddRulePopup(rule, FORM_TYPE) {
            this.isEdit = false;
            this.isCopy = false;
            if (FORM_TYPE === this.constants.FORM_TYPE.EDIT) {
                this.isEdit = true;
                this.popupTitle = "Edit Rule";
            } else if (FORM_TYPE === this.constants.FORM_TYPE.COPY) {
                this.isCopy = true;
                this.popupTitle = "Copy Rule";
            }
            this.newTmplt = [];
            if (rule != null) {
                this.rule = _.cloneDeep(rule);
                // 다국어 정의되고 바꾼다...
                const copiedTitle = this.$t('POLICY.RULE.COPY_TITLE', {'ruleName': this.rule.titl});
                this.rule.titl = this.isCopy ? copiedTitle : this.rule.titl;
                for (var cnd of this.rule.cndVal) {
                    // newTemplate 에 맞는 Template ID 넣어주기
                    for (var tmplt of this.templateList) {
                        if (cnd.tmpltId === tmplt.tmpltId) {
                            this.newTmplt.push(tmplt);
                        }
                    }
                }
            } else {
                this.rule = this.getDefaultRuleObject();
            }
            // // 수정의 경우 먼저 선택한 Action List 세팅
            this.setActionList(this.newTmplt);
            this.$refs['popUpModal'].showPopup(FORM_TYPE);
        },
        async addPolicyToCompliance() {
            if (this.pending) return;
            this.pending = true;
            const event = this.selectedPlcyScheInfo;
            const cmpnId = this.curCmpnId;
            const {plcyId, cmplId} = this.plcy;
            const data = {
                cmpnId,
                cmplId,
                plcyId,
                rvsnId: this.rvsnId,
                doCmpl: event.doCmpl
            };
            if (event.execType === 'A') {
                data.execType = event.execType;
                data.scheInfo = event;
                data.scheInfo.cmpnId = cmpnId;
                data.scheInfo.cmplId = cmplId;
            }
            const url = "/api/governance/policy/apply";
            const response  = await this.http.post(url, data);
            if (response.data.status === 'ok'){
                await this.slctPlcy(event.doCmpl);
                this.pending = false;
                 EventBus.$emit('addPolicyToCompliance');
            }
        },
        setManagementOptions: function () {
            var $moreActions = $('[data-trigger="management"]')
            $moreActions.tooltipster({
                animation: 'fade',
                side: 'bottom',
                theme: 'go-actions',
                interactive: true,
                trigger: 'click',
                arrow: false,
                functionBefore: function (instance, helper) {
                    $(helper.origin).addClass("selected")
                },
                functionAfter: function (instance, helper) {
                    $(helper.origin).removeClass("selected")
                },
                functionPosition: function (instance, helper, position) {
                    position.coord.top -= 7
                    position.coord.left = helper.geo.origin.offset.right - position.size.width
                    return position;
                }
            });
        },
        changeEditStatus(item, status) {
            this.fEdit[item] = status
        }
    }
}
</script>

<style lang="scss" scoped>
.layout-contents-container .layout-contents[data-side-expand] .left-view {
    width: 100%;
}

.layout-contents-container .layout-contents[data-side-expand] .right-view {
    position: absolute;
    right: 0;
    box-shadow: -5px 16px 8px #888888;
    width: 80%;
    max-width: 80%;
    z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/policy/policyReplica.vue